"use client";

import { TabBar } from "@/components/tab-bar";
import { useInfront } from "@/context/infront-context";
import {
  createInstrumentSlug,
  DEFAULT_CONTENT,
} from "@/services/infront/utils";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";

type Chain = { feed: number; name: string; description: string };

const ID = "turnover-list";

type TurnoverListProps = {
  chains: Chain[];
};

const TurnoverList = (props: TurnoverListProps) => {
  const { isReady, load } = useInfront();
  const router = useRouter();
  const widgetRef = useRef<any>(null);
  const [activeTab, setActiveTab] = useState<string>("");

  const activeChains = activeTab
    ? props.chains.filter((c) => c.description === activeTab)
    : props.chains.slice(0, 1);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.QuoteListWidgetOptions();

      widgetOptions.onInstrumentSelected = (instrument: {
        feed: number;
        ticker: string;
      }) => {
        router.push(createInstrumentSlug(instrument.feed, instrument.ticker));
      };

      widgetOptions.useChains = true;
      widgetOptions.chains = activeChains;
      widgetOptions.showChainSelector = false;
      widgetOptions.widgetTitle = "Mest omsatta";
      widgetOptions.defaultContent = DEFAULT_CONTENT;
      widgetOptions.enableChangeStatusColors = true;
      widgetOptions.sortable = true;
      widgetOptions.defaultSortedColumns = [
        {
          column: "TURNOVER",
          sortOrder: 0,
        },
      ];

      widgetOptions.instrumentTypes = ["STOCK"];
      widgetOptions.maxItems = 12;
      widgetOptions.columns = [
        {
          name: "TICKER",
          flag: true,
        },
        "LAST",
        "CURRENCY",
        "PCT_CHANGE",
        {
          name: "TURNOVER",
          hidden: true,
        },
      ];

      widgetRef.current = window.infront.quoteList(`#${ID}`, widgetOptions);
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, activeTab, router]);

  const tabs = props.chains.map((c) => c.description);
  const selectedTab = activeTab || tabs[0];

  return (
    <div className="card [&_.cell-mininav__btn]:hidden">
      <TabBar
        tabs={tabs.map((t) => ({ label: t, value: t }))}
        active={selectedTab}
        onChange={setActiveTab}
      />
      <div id={ID} />
    </div>
  );
};

export default TurnoverList;
